import Component from './component.vue';
import { Variants } from './enums';

export { Variants };
export default Component;



// WEBPACK FOOTER //
// ./src/components/calendar/day/index.ts